'use es6';

import { ACTIVE_CURRENCY_CODE_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';
export const updateActiveCurrencyCode = payload => {
  return {
    type: ACTIVE_CURRENCY_CODE_UPDATED,
    payload
  };
};